import React, { FC } from 'react';
import cls from 'classnames';

import styles from './index.module.sass';

interface DescriptionProps {
  fullWidthOnMobile?: boolean;
  gridAlign?: boolean;
  headline?: string;
  text?: string;
}

const Description: FC<DescriptionProps> = ({ fullWidthOnMobile, gridAlign, headline, text }) =>
  !headline && !text ? null : (
    <div
      className={cls( fullWidthOnMobile ? styles.fullWidthOnMobile : styles.paired, {
        [styles.gridAlign]: gridAlign,
      })}
    >
      {headline && <h1>{headline}</h1>}

      {text && (
        <div className="spec__collection-description" dangerouslySetInnerHTML={{ __html: text }} />
      )}
    </div>
  );

export default Description;
